import { useNetSuiteExpenseReportExpenseLinesFieldSettings } from 'shared/hooks';

import { GroupEditItemsField } from '../../../hooks';
import { isFieldReadOnly, isFieldVisible } from '../../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const getGroupEditItemsAvailableFields = (
    fieldSettings: ReturnType<typeof useNetSuiteExpenseReportExpenseLinesFieldSettings>
) => {
    const availableFields: GroupEditItemsField[] = [];

    if (isFieldVisible(fieldSettings.category) && !isFieldReadOnly(fieldSettings.category)) {
        availableFields.push(GroupEditItemsField.Category);
    }

    if (isFieldVisible(fieldSettings.account) && !isFieldReadOnly(fieldSettings.account)) {
        availableFields.push(GroupEditItemsField.ExpenseAccount);
    }

    if (isFieldVisible(fieldSettings.currency) && !isFieldReadOnly(fieldSettings.currency)) {
        availableFields.push(GroupEditItemsField.Currency);
    }

    if (isFieldVisible(fieldSettings.taxCode) && !isFieldReadOnly(fieldSettings.taxCode)) {
        availableFields.push(GroupEditItemsField.TaxCode);
    }

    if (isFieldVisible(fieldSettings.department) && !isFieldReadOnly(fieldSettings.department)) {
        availableFields.push(GroupEditItemsField.Department);
    }

    if (isFieldVisible(fieldSettings.class) && !isFieldReadOnly(fieldSettings.class)) {
        availableFields.push(GroupEditItemsField.Class);
    }

    if (isFieldVisible(fieldSettings.location) && !isFieldReadOnly(fieldSettings.location)) {
        availableFields.push(GroupEditItemsField.Location);
    }

    if (isFieldVisible(fieldSettings.customer) && !isFieldReadOnly(fieldSettings.customer)) {
        availableFields.push(GroupEditItemsField.Customer);
    }

    return availableFields;
};
